var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',[_c('SekretariatComp')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-center"},[_c('h1',{staticClass:"sz-kath-title"},[_vm._v(" Sekretariat ")])])
}]

export { render, staticRenderFns }